import { Injectable } from '@angular/core';
import { ImageEditingType, QuestionEditingOptions } from '@examdojo/models/question-editor';
import { QuestionEntityQuery, QuestionItemsFormService } from '@examdojo/question';
import { BehaviorSubject, distinctUntilChanged, map } from 'rxjs';
import { QuestionEditorService } from './question-editor.service';

@Injectable()
export class QuestionEditorItemsFormService extends QuestionItemsFormService {
  constructor(
    private readonly questionEditorService: QuestionEditorService,
    private readonly questionEntityQuery: QuestionEntityQuery,
  ) {
    super();
  }

  readonly form = this.questionEditorService.questionForm.controls.question_items;

  override readonly questionItems$ = this.questionEntityQuery.selectActiveId().pipe(
    distinctUntilChanged(),
    map((id) => {
      if (!id) {
        return [];
      }

      return this.questionEntityQuery.getUIEntity(id)?.question.question_items ?? [];
    }),
  );

  override readonly generateSolutionQuestionId$ = this.questionEntityQuery.selectActiveId();

  readonly editingOptions$ = new BehaviorSubject<QuestionEditingOptions | null>({
    allowImageEditing: [ImageEditingType.Original, ImageEditingType.Generated],
    allowQuestionEditing: true,
    allowMarkschemeEditing: true,
    allowMcqEditing: true,
    allowMarkschemeStructureEditing: true,
    allowMcqStructureEditing: true,
    hideBadges: false,
    showMcqMetadata: true,
  });
}
